import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=7d70ccfa&scoped=true&"
import script from "./AccountDetails.vue?vue&type=script&lang=js&"
export * from "./AccountDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetails.vue?vue&type=style&index=0&id=7d70ccfa&scoped=true&scss=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d70ccfa",
  null
  
)

export default component.exports
import {QSeparator,QForm,QItemLabel,QField,QOptionGroup,QInput,QAvatar,QBtn} from 'quasar'
component.options.components = Object.assign({QSeparator,QForm,QItemLabel,QField,QOptionGroup,QInput,QAvatar,QBtn}, component.options.components || {})
